import { MessageCircle, Phone, MapPin, Globe, Navigation } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, Overline } from "./Reveal";
import { BRAND, NAV, waLink, telLink, mapsLink, mapsEmbed } from "../../lib/data";
import { LOCAL_PAGES } from "../../lib/localPages";

const FOOTER_NAV = NAV.filter((n) => n.label !== "Solusi");

export const Contact = () => (
  <>
    {/* Big CTA */}
    <section className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] bg-[#071A33] p-10 md:p-20 text-center">
            <div className="absolute inset-0 opacity-70 [background:radial-gradient(60%_80%_at_50%_120%,rgba(11,99,246,0.55),transparent_60%),radial-gradient(40%_60%_at_10%_0%,rgba(22,199,232,0.35),transparent_60%)]" />
            <div className="relative">
              <h2 className="font-heading font-extrabold text-white text-3xl md:text-5xl tracking-tight max-w-3xl mx-auto leading-tight">
                Punya Kebutuhan CCTV, WiFi, Parabola atau Teknologi?
              </h2>
              <p className="mt-5 text-white/70 max-w-xl mx-auto text-base md:text-lg">
                Diskusikan kebutuhan Anda bersama SATCOM MEDIA TEKNOLOGI.
              </p>
              <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="cta-whatsapp"
                  className="inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold px-8 py-4 transition-colors shadow-xl shadow-[#25D366]/30 hover:scale-[1.03]"
                >
                  <MessageCircle className="h-5 w-5" /> Chat WhatsApp Sekarang
                </a>
                <a
                  href={mapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="cta-maps"
                  className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 backdrop-blur text-white font-semibold px-8 py-4 hover:bg-white/10 transition-colors"
                >
                  <Navigation className="h-5 w-5" /> Lihat Lokasi
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>

    {/* Contact */}
    <section id="kontak" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-2xl">
          <Reveal><Overline>Kontak</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-heading font-bold text-[#111827] text-4xl md:text-5xl tracking-tight">
              Hubungi SATCOM MEDIA TEKNOLOGI
            </h2>
          </Reveal>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-8">
          <div className="space-y-4">
            {[
              { icon: MapPin, label: "Alamat", value: BRAND.address },
              { icon: Phone, label: "WhatsApp / Telepon", value: BRAND.phone },
              { icon: Globe, label: "Website", value: BRAND.website },
            ].map((c, i) => (
              <Reveal key={c.label} delay={i * 0.06}>
                <div className="flex gap-4 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
                  <span className="grid place-items-center h-12 w-12 rounded-xl bg-[#F5F7FA] text-[#0B63F6] shrink-0">
                    <c.icon className="h-5 w-5" />
                  </span>
                  <div>
                    <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#0B63F6]">{c.label}</p>
                    <p className="mt-1 text-[#111827] leading-relaxed">{c.value}</p>
                  </div>
                </div>
              </Reveal>
            ))}

            <Reveal delay={0.2}>
              <div className="flex flex-wrap gap-3 pt-2">
                <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp"
                  className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white font-semibold px-6 py-3 hover:bg-[#1ebe5a] transition-colors">
                  <MessageCircle className="h-4 w-4" /> WhatsApp
                </a>
                <a href={telLink} data-testid="contact-phone"
                  className="inline-flex items-center gap-2 rounded-full bg-[#0B63F6] text-white font-semibold px-6 py-3 hover:bg-[#16C7E8] transition-colors">
                  <Phone className="h-4 w-4" /> Telepon
                </a>
                <a href={mapsLink} target="_blank" rel="noopener noreferrer" data-testid="contact-maps"
                  className="inline-flex items-center gap-2 rounded-full border border-gray-200 text-[#111827] font-semibold px-6 py-3 hover:bg-[#F5F7FA] transition-colors">
                  <Navigation className="h-4 w-4" /> Google Maps
                </a>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <div className="rounded-2xl overflow-hidden border border-gray-100 shadow-sm h-[360px] lg:h-full min-h-[360px]">
              <iframe
                title="Lokasi SATCOM MEDIA TEKNOLOGI"
                src={mapsEmbed}
                className="w-full h-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>

    {/* Footer */}
    <footer className="bg-[#071A33] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo-satcom.png" alt="SATCOM MEDIA TEKNOLOGI" className="h-10 w-auto" loading="lazy" />
            </div>
            <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-xs">
              Solusi CCTV, parabola, WiFi, jaringan, hardware dan software untuk
              kebutuhan rumah maupun bisnis.
            </p>
          </div>

          <div>
            <p className="font-semibold text-sm uppercase tracking-[0.2em] text-[#16C7E8]">Navigasi</p>
            <ul className="mt-4 space-y-2.5">
              {FOOTER_NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-white/70 hover:text-white text-sm transition-colors">{n.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-semibold text-sm uppercase tracking-[0.2em] text-[#16C7E8]">Kontak</p>
            <ul className="mt-4 space-y-2.5 text-sm text-white/70">
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#16C7E8]" /> {BRAND.phone}</li>
              <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#16C7E8]" /> Rangkasbitung, Lebak, Banten</li>
              <li className="flex items-center gap-2"><Globe className="h-4 w-4 text-[#16C7E8]" /> {BRAND.website}</li>
            </ul>
            <a href={waLink()} target="_blank" rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white text-sm font-semibold px-5 py-2.5 hover:bg-[#1ebe5a] transition-colors">
              <MessageCircle className="h-4 w-4" /> Konsultasi via WhatsApp
            </a>
          </div>

          <div>
            <p className="font-semibold text-sm uppercase tracking-[0.2em] text-[#16C7E8]">Area Layanan</p>
            <ul className="mt-4 space-y-2.5">
              {LOCAL_PAGES.map((p) => (
                <li key={p.slug}>
                  <Link to={`/layanan/${p.slug}`} data-testid={`footer-local-${p.slug}`}
                    className="text-white/70 hover:text-white text-sm transition-colors">{p.h1}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 text-center text-white/50 text-sm">
          © 2026 SATCOM MEDIA TEKNOLOGI. All Rights Reserved.
        </div>
      </div>
    </footer>
  </>
);
